<template lang="pug">
    .z-modal-sidebar(v-bind:class="{ active: show }")
        md-button.md-icon-button.md-dense.close.small(v-on:click="hide")
            md-icon close
            md-tooltip(md-direction="bottom" md-delay="500") Закрыть
        .md-title(v-html="title")
        slot
</template>
<script>
    export default {
        name: 'z-modal-sidebar',
        components: {},
        props: [
            'title'
        ],
        data() {
            return {
                show: false
            }
        },
        created() {
            this.listeners();
        },
        watch: {},
        computed: {},
        methods: {
            listeners() {
                this.$on('show', () => {
                    this.show  = true;
                });
            },
            
            hide() {
                this.$emit('hide');
                this.show = false;
            }
        }
    }
</script>
<style lang="sass">
.z-modal-sidebar
    border-left: 1px solid #e0e0e0
    box-shadow: -2px 0px 10px 2px rgba(0, 0, 0, .2)
    z-index: 150
    position: fixed
    top: 48px
    right: 0px
    bottom: 0
    width: 1200px
    height: calc(100vh - 48px)
    transition: 0.5s ease-in-out
    overflow: hidden
    background: #fff
    display: none
    padding: 20px 10px 10px;
    &.active
        display: block
    .close
        position: absolute
        right: 16px
        top: 7px
</style>


// WEBPACK FOOTER //
// ZModalSidebar.vue?0bc6e189